(function () {
    'use strict';

    a3_cabin_reports.controller('GroundDutyCtrl', GroundDutyCtrl);
    /**
     * @memberof CabinReports
     * @ngdoc controller
     * @name GroundDutyCtrl
     * @description 
     * Shows the ground duty information
     * @ngInject
     */
    function GroundDutyCtrl(GroundDutyFactory, CourseFactory, TrainingSessionFactory, $scope, $location, $routeParams) {
        $scope.toggleCrewList = toggleCrewList
        $scope.toggleEditMode = toggleEditMode;
        $scope.selectTrainee = selectTrainee;
        $scope.refresh = refresh;
        $scope.refreshSuccess = true;
        $scope.isRefreshing = false;
        $scope.instructors = [];
        $scope.trainees = [];
        var groundDutyId = Number($routeParams.groundDutyId);
        var groundDuty = GroundDutyFactory.getGroundDutyFromStorage(groundDutyId);
        $scope.dutyCourses = GroundDutyFactory.getGroundDutyActiveCourses(groundDutyId);
        $scope.groundDutyId = groundDutyId;


        if (!groundDuty) {
            // go to dashboard if no groundDuty
            $location.path("/");
        } else {
            //Toggle trainees
            groundDuty.Trainees.forEach(function (relatedTrainees) {
                relatedTrainees.isCollapsed = false;
                relatedTrainees.dynamicSize = 10;
            });

            //Collect all trainees in list
            var traineesFlat = [];
            groundDuty.Trainees.forEach(function (related) {
                related.CrewMembers.forEach(function (trainee) {
                    traineesFlat.push(trainee);
                });
            });
            groundDuty.traineesFlat = traineesFlat;


            if (groundDuty.RelatedGroundDuties) {
                $scope.courses = GroundDutyFactory.getGroundDutyActiveCourses(groundDutyId);
            }

            updateCrewMemberScopes(groundDuty);

            $scope.groundDuty = groundDuty;
            $scope.groundDutyId = groundDutyId;
        }

        function toggleCrewList(relatedTrainees) {
            relatedTrainees.isCollapsed = !relatedTrainees.isCollapsed;

            if (relatedTrainees.isCollapsed) relatedTrainees.dynamicSize = relatedTrainees.CrewMembers.length;
            else relatedTrainees.dynamicSize = 10;
        }

        function toggleEditMode(elem, className) {
            $('body').find('div#' + elem + ' > div').not('.tip').hide("slow");
            $('body').find('div#' + elem + ' div.' + className).not('.tip').show("slow");
        }

        /**
         * Edit ground duty's attendance list
         * @param {object} trainee 
         */
        function selectTrainee(trainee) {
            //Value will be saved in ground duty's crew members
            trainee.Absent = !trainee.Absent;
            GroundDutyFactory.updateGroundDuty($scope.groundDuty);
        }

        /**
         * Sync ground duty
         */
        function refresh() {
            var courseIds = $scope.dutyCourses.map(x => x.CourseId).filter(onlyUnique);

            var refreshGroundDuty = {
                DutyId: groundDutyId,
                CourseIds: courseIds
            };

            $scope.isRefreshing = true;

            //get latest info
            GroundDutyFactory.refresh(refreshGroundDuty, function (responseData) {

                $scope.isRefreshing = false;
                $scope.refreshSuccess = true;

                //update ground duty.
                var groundDuty = responseData.data.GroundDuty;
                if (groundDuty && groundDuty.Id != 0 && groundDuty.Code) {
                    GroundDutyFactory.mergeGroundDutyInfo(groundDuty);
                }

                //Save training
                var trainingCourses = responseData.data.TrainingCourses;
                if (trainingCourses && trainingCourses.length) {
                    trainingCourses.forEach(function (trainingCourse) {
                        CourseFactory.upsertCourse(trainingCourse, function (course) {
                            TrainingSessionFactory.applyTraineeInfoToSession(course, course.Id, $scope.groundDuty.DutyDateS, groundDutyId, function (session) {
                            });
                        });
                    });
                }

                updateCrewMemberScopes(groundDuty);

            })
                .catch(function () {
                    $scope.refreshSuccess = false;
                    $scope.isRefreshing = false;
                });
        }

        function updateCrewMemberScopes(groundDuty) {
            if (groundDuty && groundDuty.RelatedGroundDuties && groundDuty.RelatedGroundDuties.length > 0) {
                var relatedDutyIns = groundDuty.RelatedGroundDuties.filter(x => x.IsInstructor == true);
                if (relatedDutyIns && relatedDutyIns.length > 0) {
                    $scope.instructors = relatedDutyIns[0].CrewMembers;
                }
                var relatedDutyTr = groundDuty.RelatedGroundDuties.filter(x => x.IsInstructor == false);
                if (relatedDutyTr && relatedDutyTr.length > 0) {
                    $scope.trainees = relatedDutyTr.flatMap(a => a.CrewMembers);
                }
            }
        }

        function onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        }
    }
})();